export const iframeStyle =
    "visibility: visible !important; position: fixed; border-width: 0px; z-index: 10; bottom: 20px; left: unset; right: 20px;";
